module.exports = __webpack_public_path__ + "static/quiz_difficulty_title_bg-1a8c140c052ca214e8802283ac333a82.svg";